import Vue from "vue";
// import md5 from "js-md5";
import router from "@/router";
import config from "@/config";
import errorTags from "@/errorTags";
import { helpers } from "vuelidate/lib/validators";

export default {
  namespaced: true,
  state: {
    _loading: {
      login: false,
      logout: false,
      getAccountList: false,
      getKeyList: false,
      getChildPositionTaking: false,
      getChildCommission: false,
      getChildBetLimit: false,
      getDashboardInfo: false,
      getSportTypeWinlose: false,
      updateCommissionMMO: false,
      updatePositionTakingMMO: false,
      getScheduleList: false,
      getWallet: false,
      checkDirectDownline: false,
      getPlatform: false,
      updatePromoStatus: false,
      getBankAccount: false,
      getAccountSocial: false,
      upsertBankAccount: false,
      upsertAccountSocial: false,
    },
    login: "",
    account: "",
    ptList: "",
    blList: "",
    operatorblList: "",
    selectedID: "",
    selectedType: "",
    selectedSystemType: "",
    selectedCurrency: "",
    redirectType: "",
    selectedProvider: "",
    scheduleList: "",
    wallet: "",
    platform: "",
    platformLookUp: [],
    gameTypeLookUp: [],
    leagueLookUp: [],
    currencyLookUp: [],
    providerLookUp: [],
    tier: [],
    attachmentPath: "",
    defaultComm: {
      "Table": [
        {
          "platform": "SPORTSBOOK",
          "hdp_a": 1.0000,
          "hdp_b": 0.5000,
          "hdp_c": 0.7500,
          "hdp_d": 1.0000,
          "hdp_e": 1.2500,
          "hdp_f": 1.5000,
          "hdp_g": 0.0000,
          "hdp_h": 0.0000,
          "hdp_i": 0.0000,
          "hdp_j": 0.0000,
          "one_x_two": 0.2500,
          "others": 1.0000,
          "hdp_packages": "A"
        }
      ],
      "Table1": [
        {
          "platform": "SPORTSBOOK",
          "hdp": 2,
          "parlay_a": 7.0000,
          "parlay_b": 15.0000,
          "parlay_c": 0.0000,
          "parlay_d": 0.0000,
          "parlay_e": 0.0000
      }
      ],
      "Table2": [
        {
          "platform": "SLOTS",
          "comm_rate": 0.7000
        }
      ],
      "Table3": [
        {
          "platform": "LIVECASINO",
          "comm_rate": 0.8000
        }
      ]
    },
    defaultBL: {
      "Table": [
        {
          "platform": "SPORTSBOOK",
          "sport_type": "BASEBALL",
          "min_bet": 1.0000,
          "max_bet": 10000000.0000,
          "max_per_match": 100000000.0000
        },
        {
          "platform": "SPORTSBOOK",
          "sport_type": "BASKETBALL",
          "min_bet": 1.0000,
          "max_bet": 10000000.0000,
          "max_per_match": 100000000.0000
        },
        {
          "platform": "SPORTSBOOK",
          "sport_type": "ESPORTS",
          "min_bet": 1.0000,
          "max_bet": 10000000.0000,
          "max_per_match": 100000000.0000
        },
        {
          "platform": "SPORTSBOOK",
          "sport_type": "OTHERS",
          "min_bet": 1.0000,
          "max_bet": 10000000.0000,
          "max_per_match": 100000000.0000
        },
        {
          "platform": "SPORTSBOOK",
          "sport_type": "PARLAY",
          "min_bet": 1.0000,
          "max_bet": 10000000.0000,
          "max_per_match": 100000000.0000
        },
        {
          "platform": "SPORTSBOOK",
          "sport_type": "SOCCER",
          "min_bet": 1.0000,
          "max_bet": 10000000.0000,
          "max_per_match": 100000000.0000
        },
        {
          "platform": "SPORTSBOOK",
          "sport_type": "TENNIS",
          "min_bet": 1.0000,
          "max_bet": 10000000.0000,
          "max_per_match": 100000000.0000
        }
    ],
    "Table1": [
      {
        "platform": "LIVECASINO",
        "bet_limit_package": "A,B,C,D,E,F,G"
      }
    ]
    },
    defaultPT: {
      "Table": [
        {
          "platform": "SPORTSBOOK",
          "bet_type": "1X2",
          "upline_pt": .0000,
          "account_pt": 100.0000,
          "upline_remaining": 0.0000,
          "account_min": 0.0000
        },
        {
          "platform": "SPORTSBOOK",
          "bet_type": "HDP",
          "upline_pt": .0000,
          "account_pt": 100.0000,
          "upline_remaining": 0.0000,
          "account_min": 0.0000
        },
        {
          "platform": "SPORTSBOOK",
          "bet_type": "HDPMMO",
          "upline_pt": 0.0000,
          "account_pt": 100.0000,
          "upline_remaining": 0.0000,
          "account_min": 0.0000
        },
        {
          "platform": "SPORTSBOOK",
          "bet_type": "OTHERS",
          "upline_pt": 0.0000,
          "account_pt": 100.0000,
          "upline_remaining": 0.0000,
          "account_min": 0.0000
        },
        {
          "platform": "SPORTSBOOK",
          "bet_type": "PARLAY",
          "upline_pt": 0.0000,
          "account_pt": 100.0000,
          "upline_remaining": 0.0000,
          "account_min": 0.0000
        },
        {
          "platform": "SPORTSBOOK",
          "bet_type": "PARLAYMMO",
          "upline_pt": 0.0000,
          "account_pt": 100.0000,
          "upline_remaining": 0.0000,
          "account_min": 0.0000
        }
    ],
    "Table1": [
        {
          "platform": "SLOTS",
          "upline_pt": 0.0000,
          "account_pt": 100.0000,
          "upline_remaining": 0.0000,
          "account_min": 0.0000
        }
    ],
    "Table2": [
        {
          "platform": "LIVECASINO",
          "upline_pt": 0.0000,
          "account_pt": 100.0000,
          "upline_remaining": 0.0000,
          "account_min": 0.0000
        }
    ]
    },
    defaultSchedule: {
      "Table": [
        {
          "monday": true,
          "tuesday": true,
          "wednesday": true,
          "thursday": true,
          "friday": true,
          "saturday": true,
          "sunday": true
        }
      ]
    }
  },
  mutations: {
    updateSelectedID(state, payload) {
      state.selectedID = payload;
    },
    updateSelectedType(state, payload) {
      state.selectedType = payload;
    },
    updateSelectedSystemType(state, payload) {
      state.selectedSystemType = payload;
    },
    updateSelectedCurrency(state, payload) {
      state.selectedCurrency = payload;
    },
    updateTier(state, payload) {
      state.tier = payload;
    },
    updateRedirectType(state, payload) {
      state.redirectType = payload;
    },
    updateSelectedProvider(state, payload) {
      state.selectedProvider = payload;
    },
    updateSecurityDisabled(state, payload) {
      state.profile.security_disabled = payload.security_disabled;
    },
    updateSecurityTag(state, payload) {
      state.profile.security_tag = payload.security_tag;
    },
    updateProfile(state, payload) {
      state.profile.full_name = payload.name;
      state.profile.contact_phone = payload.phone;
      state.profile.contact_email = payload.email;
    },
    update(state, payload) {
      state.login = payload.data.login[0];
      state.account = payload.data.account[0];
      state.profile = payload.data.profile[0];
      state.access = payload.data.access[0] || "";
    },
    updatePT(state, payload) {
      // console.log('updatePT', payload)
      state.ptList = payload.data;
    },
    updateCM(state, payload) {
      state.cmList = payload.data;
    },
    updateBL(state, payload) {
      // console.log('updateBL', payload)
      state.blList = payload.data;
    },
    updateOperatorBL(state, payload) {
      state.operatorblList = payload.betlimit;
    },
    updateSchedule(state, payload) {
      state.scheduleList = payload.data;
    },
    updateWallet(state, payload) {
      state.wallet = payload.data;
    },
    updatePlatform(state, payload) {
      state.platform = payload.data;
    },
    updatePlatformLookUp(state, payload) {
      state.platformLookUp = payload.data;
    },
    updateGameTypeLookUp(state, payload) {
      state.gameTypeLookUp = payload.data;
    },
    updateCurrencyLookUp(state, payload) {
      state.currencyLookUp = payload.data;
    },
    updateLeagueLookUp(state, payload) {
      state.leagueLookUp = payload.data;
    },
    updateCreditUsedDownline(state, payload) {
      state.credit_used_downline = payload.data;
    },
    updateAttachmentPath(state, payload) {
      state.attachmentPath = payload;
    },
    delete(state) {
      console.log("user.delete", state);
      state.login = "";
      state.account = "";
      state.profile = "";
      state.access = "";
      state.ptList = "";
      state.cmList = "";
      state.blList = "";
      state.operatorblList = "";
      state.wallet = "";
      state.credit_used_downline = "";
      state.scheduleList = "";
      state.platform = "";
      state.selectedID = "";
      state.selectedType = "";
      state.selectedSystemType = "";
      state.selectedCurrency = "";
      state.attachmentPath = "";
      state.redirectType = "";
      state.selectedProvider = "";
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    }
  },
  actions: {
    setSelectedID(context, payload) {
      context.commit("updateSelectedID", payload);
    },
    setSelectedType(context, payload) {
      context.commit("updateSelectedType", payload);
    },
    setSelectedSystemType(context, payload) {
      context.commit("updateSelectedSystemType", payload);
    },
    setSelectedCurrency(context, payload) {
      context.commit("updateSelectedCurrency", payload);
    },
    setRedirectType(context, payload) {
      context.commit("updateRedirectType", payload);
    },
    setSelectedProvider(context, payload) {
      context.commit("updateSelectedProvider", payload);
    },
    setTier(context, payload) {
      context.commit("updateTier", payload);
    },
    setComm(context, payload) {
      context.commit("updateCM", payload);
    },
    setBL(context, payload) {
      // console.log('setBL')
      context.commit("updateBL", payload);
    },
    setPT(context, payload) {
      // console.log('setPT')
      context.commit("updatePT", payload);
    },
    setSchedule(context, payload) {
      // console.log('setSchedule')
      context.commit("updateSchedule", payload)
    },
    setAttachmentPath(context, payload) {
      context.commit("updateAttachmentPath", payload);
    },
    login(context, user) {
      const url = config.loginUrl();
      const body = {
        login_id: user.login_id,
        password: user.password,
        client_ip: user.client_ip
      };
      const feedback = {
        data: [],
        redirect: "",
        success: false,
        errorTag: errorTags.login.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.errorTag = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.errorTag = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.errorTag = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.errorTag = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var authToken = null;
                  var profileStatus = null;
                  var securityDisabled = true;
                  var data = null;
                  // authToken = successResponse.body.data.login[0].auth_token;
                  authToken = successResponse.body.ds.account_login[0].auth_token;

                  try {
                    if (authToken) {
                      data = successResponse.body.ds;
                      profileStatus =
                        // successResponse.body.data.profile[0].status;
                        successResponse.body.ds.account_profile[0].profile_status;
                      switch (profileStatus) {
                        case "NEW":
                          let role =
                            // successResponse.body.data.login[0].authority_role;
                            successResponse.body.ds.account_login[0].authority_role;
                          if (role == "SUB_PRI") {
                            feedback.redirect = "/resetPassword";
                          } else {
                            feedback.redirect = "/firstTime";
                          }
                          break;
                        case "RESET":
                          securityDisabled =
                            successResponse.body.ds.account_profile[0]
                              .security_disabled == 0;
                          if (securityDisabled) {
                            feedback.redirect = "/security";
                          } else {
                            feedback.redirect = "/resetPassword";
                          }
                          break;
                        case "ACTIVE":
                          securityDisabled =
                            // successResponse.body.data.profile[0]
                            successResponse.body.ds.account_profile[0]
                              .security_disabled == 0;
                          if (securityDisabled) {
                            feedback.redirect = "/security";
                          } else {
                            feedback.redirect = "/overview";
                          }
                          break;
                      }

                      feedback.data = data;
                      data = {
                        login: data.account_login,
                        account: data.account,
                        profile: data.account_profile,
                        access: data.account_authority
                      };

                      context.commit("update", { data });
                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.errorTag = errorTags.login.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.errorTag = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.errorTag = errorTags.login.systemFailed;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorTags.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    },
    firstTime(context, user) {
      const url = config.secAccountFullUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        new_login_id: user.new_login_id,
        new_password: user.new_password,
        security_tag: user.security_tag,
        security_code: user.security_code,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.firstTime.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("new_login_id" in user)) {
          feedback.errorTag = errorTags.firstTime.newUsernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.firstTime.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_tag" in user)) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_code" in user)) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_login_id.length <= 0) {
          feedback.errorTag = errorTags.firstTime.newUsernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.firstTime.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_tag.length <= 0) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_code.length <= 0) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.firstTime == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "firstTime", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.errorTag = errorTags.firstTime.failed;
                    reject(feedback);
                  }
                } else {
                  // context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              context.commit("delete");
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    securityDisable(context, user) {
      const url = config.securityDisableUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.security.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.securityDisable == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "securityDisable",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "securityDisable",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    let security_disabled = 1;
                    let security_tag = "";
                    context.commit("updateSecurityTag", { security_tag });
                    context.commit("updateSecurityDisabled", { security_disabled });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.security.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "securityDisable",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    securityValidate(context, user) {
      const url = config.securityValidateUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        security_code: user.security_code,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.security.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("security_code" in user)) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.security_code.length <= 0) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.securityValidate == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "securityValidate",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "securityValidate",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.security.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "securityValidate",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    securityUpdate(context, user) {
      const url = config.securityUpdateUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        security_tag: user.security_tag,
        security_code: user.security_code,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.security.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("security_tag" in user)) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("security_code" in user)) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.security_tag.length <= 0) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.security_code.length <= 0) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.securityUpdate == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "securityUpdate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "securityUpdate",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    var security_tag = body.security_tag;
                    var security_disabled = 0;
                    context.commit("updateSecurityDisabled", { security_disabled });
                    context.commit("updateSecurityTag", { security_tag });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.security.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "securityUpdate",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addSubAccount(context, user) {
      const url = config.addSubAccountUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        new_login_id: user.new_login_id,
        new_password: user.new_password,
        authority_option: user.authority_option.join(),
        full_name: user.full_name,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email,
        client_ip : user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.addAccount.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("new_login_id" in user)) {
          feedback.errorTag = errorTags.addAccount.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.addAccount.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_login_id.length <= 0) {
          feedback.errorTag = errorTags.addAccount.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.addAccount.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addAccount == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addSubAccount", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addSubAccount",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.addAccount.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addSubAccount",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSubAccountDetails(context, user) {
      const url = config.getSubAccountDetailsUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        sub_login_id: user.sub_login_id,
        client_ip: user.client_ip
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountDetails.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("sub_login_id" in user)) {
          feedback.errorTag = errorTags.getAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.sub_login_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getAccountDetails == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSubAccountDetails",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSubAccountDetails",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountDetails.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSubAccountDetails",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSubAccountList(context, user) {
      const url = config.getSubAccountListUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        sub_login_id: user.search_id,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type,
        client_ip: user.client_ip
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSubAccountList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSubAccountList",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSubAccountList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.dt;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSubAccountList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addAccount(context, user) {
      const url = config.addAccountUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.account_id,
        password: user.password,
        full_name: user.full_name,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email,
        monday: user.payment.monday,
        tuesday: user.payment.tuesday,
        wednesday: user.payment.wednesday,
        thursday: user.payment.thursday,
        friday: user.payment.friday,
        saturday: user.payment.saturday,
        sunday: user.payment.sunday,
        credit_limit: user.credit_limit,
        member_credit_limit: user.member_credit_limit,
        win_limit_multiplier: user.win_limit_multiplier,
        daily_reset: user.daily_reset,
        hdp_upline_pt: user.pt.soccer_hdp_upline_pt,
        hdp_account_pt: user.pt.soccer_hdp_account_pt,
        hdp_upline_remaining: user.pt.soccer_hdp_upline_remaining,
        hdp_account_min: user.pt.soccer_hdp_account_min,
        oxt_upline_pt: user.pt.soccer_1x2_upline_pt,
        oxt_account_pt: user.pt.soccer_1x2_account_pt,
        oxt_upline_remaining: user.pt.soccer_1x2_upline_remaining,
        oxt_account_min: user.pt.soccer_1x2_account_min,
        others_upline_pt: user.pt.soccer_others_upline_pt,
        others_account_pt: user.pt.soccer_others_account_pt,
        others_upline_remaining: user.pt.soccer_others_upline_remaining,
        others_account_min: user.pt.soccer_others_account_min,
        parlay_upline_pt: user.pt.parlay_upline_pt,
        parlay_account_pt: user.pt.parlay_account_pt,
        parlay_upline_remaining: user.pt.parlay_upline_remaining,
        parlay_account_min: user.pt.parlay_account_min,
        slots_upline_pt: user.pt.slots_upline_pt,
        slots_account_pt: user.pt.slots_account_pt,
        slots_upline_remaining: user.pt.slots_upline_remaining,
        slots_account_min: user.pt.slots_account_min,
        slots_account_min: user.pt.slots_account_min,
        livecasino_upline_pt: user.pt.livecasino_upline_pt,
        livecasino_account_pt: user.pt.livecasino_account_pt,
        livecasino_upline_remaining: user.pt.livecasino_upline_remaining,
        livecasino_account_min: user.pt.livecasino_account_min,
        comm_hdp_a: user.cm.comm_sportsbook_hdp_a,
        comm_hdp_b: user.cm.comm_sportsbook_hdp_b,
        comm_hdp_c: user.cm.comm_sportsbook_hdp_c,
        comm_hdp_d: user.cm.comm_sportsbook_hdp_d,
        comm_hdp_e: user.cm.comm_sportsbook_hdp_e,
        comm_hdp_f: user.cm.comm_sportsbook_hdp_f,
        comm_hdp_g: user.cm.comm_sportsbook_hdp_g,
        comm_hdp_h: user.cm.comm_sportsbook_hdp_h,
        comm_hdp_i: user.cm.comm_sportsbook_hdp_i,
        comm_hdp_j: user.cm.comm_sportsbook_hdp_j,
        comm_1x2: user.cm.comm_sportsbook_1x2,
        comm_others: user.cm.comm_sportsbook_others,
        comm_hdp_packages: user.cm.comm_sportsbook_hdp_packages,
        comm_slots: user.cm.comm_slots,
        comm_livecasino: user.cm.comm_casino,
        soccer_min_bet: user.bl.soccer_min_bet,
        soccer_max_bet: user.bl.soccer_max_bet,
        soccer_max_per_match: user.bl.soccer_max_per_match,
        basketball_min_bet: user.bl.basketball_min_bet,
        basketball_max_bet: user.bl.basketball_max_bet,
        basketball_max_per_match: user.bl.basketball_max_per_match,
        tennis_min_bet: user.bl.tennis_min_bet,
        tennis_max_bet: user.bl.tennis_max_bet,
        tennis_max_per_match: user.bl.tennis_max_per_match,
        baseball_min_bet: user.bl.baseball_min_bet,
        baseball_max_bet: user.bl.baseball_max_bet,
        baseball_max_per_match: user.bl.baseball_max_per_match,
        parlay_min_bet: user.bl.parlay_min_bet,
        parlay_max_bet: user.bl.parlay_max_bet,
        parlay_max_per_match: user.bl.parlay_max_per_match,
        esports_min_bet: user.bl.esports_min_bet,
        esports_max_bet: user.bl.esports_max_bet,
        esports_max_per_match: user.bl.esports_max_per_match,
        others_min_bet: user.bl.others_min_bet,
        others_max_bet: user.bl.others_max_bet,
        others_max_per_match: user.bl.others_max_per_match,
        livecasino_bet_limit_package: this.state.user.account.account_type != 2 ? user.bl.livecasino_bet_limit_packages.join(',') : user.bl.livecasino_bet_limit_packages,
        hdp_mmo_upline_pt: user.pt.hdp_mmo_upline_pt,
        hdp_mmo_account_pt: user.pt.hdp_mmo_account_pt,
        hdp_mmo_upline_remaining: user.pt.hdp_mmo_upline_remaining,
        hdp_mmo_account_min: user.pt.hdp_mmo_account_min,
        parlay_mmo_upline_pt: user.pt.parlay_mmo_upline_pt,
        parlay_mmo_account_pt: user.pt.parlay_mmo_account_pt,
        parlay_mmo_upline_remaining: user.pt.parlay_mmo_upline_remaining,
        parlay_mmo_account_min: user.pt.parlay_mmo_account_min,
        comm_hdp_mmo: user.cm.comm_hdp_mmo,
        comm_parlay_mmo_a: user.cm.comm_parlay_mmo_a,
        comm_parlay_mmo_b: user.cm.comm_parlay_mmo_b,
        // pt: user.pt,
        // cm: user.cm,
        // bl: user.bl
      };
      const feedback = {
        success: false,
        errorTag: errorTags.addAccount.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.addAccount == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addAccount", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addAccount",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.addAccount.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addAccount",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addShareHolder(context, user) {
      const url = config.addShareholderUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.account_id,
        password: user.password,
        full_name: user.full_name,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email,
        monday: user.payment.monday,
        tuesday: user.payment.tuesday,
        wednesday: user.payment.wednesday,
        thursday: user.payment.thursday,
        friday: user.payment.friday,
        saturday: user.payment.saturday,
        sunday: user.payment.sunday,
        credit_limit: user.credit_limit,
        member_credit_limit: user.member_credit_limit,
        downline_limit: user.downline_limit,
        currency: user.currency,
        system_type: user.system_type,
        win_limit_multiplier: user.win_limit_multiplier,
        daily_reset: user.daily_reset,
        hdp_upline_pt: user.pt.soccer_hdp_upline_pt,
        hdp_account_pt: user.pt.soccer_hdp_account_pt,
        hdp_upline_remaining: user.pt.soccer_hdp_upline_remaining,
        hdp_account_min: user.pt.soccer_hdp_account_min,
        oxt_upline_pt: user.pt.soccer_1x2_upline_pt,
        oxt_account_pt: user.pt.soccer_1x2_account_pt,
        oxt_upline_remaining: user.pt.soccer_1x2_upline_remaining,
        oxt_account_min: user.pt.soccer_1x2_account_min,
        others_upline_pt: user.pt.soccer_others_upline_pt,
        others_account_pt: user.pt.soccer_others_account_pt,
        others_upline_remaining: user.pt.soccer_others_upline_remaining,
        others_account_min: user.pt.soccer_others_account_min,
        parlay_upline_pt: user.pt.parlay_upline_pt,
        parlay_account_pt: user.pt.parlay_account_pt,
        parlay_upline_remaining: user.pt.parlay_upline_remaining,
        parlay_account_min: user.pt.parlay_account_min,
        slots_upline_pt: user.pt.slots_upline_pt,
        slots_account_pt: user.pt.slots_account_pt,
        slots_upline_remaining: user.pt.slots_upline_remaining,
        slots_account_min: user.pt.slots_account_min,
        slots_account_min: user.pt.slots_account_min,
        livecasino_upline_pt: user.pt.livecasino_upline_pt,
        livecasino_account_pt: user.pt.livecasino_account_pt,
        livecasino_upline_remaining: user.pt.livecasino_upline_remaining,
        livecasino_account_min: user.pt.livecasino_account_min,
        comm_hdp_a: user.cm.comm_sportsbook_hdp_a,
        comm_hdp_b: user.cm.comm_sportsbook_hdp_b,
        comm_hdp_c: user.cm.comm_sportsbook_hdp_c,
        comm_hdp_d: user.cm.comm_sportsbook_hdp_d,
        comm_hdp_e: user.cm.comm_sportsbook_hdp_e,
        comm_hdp_f: user.cm.comm_sportsbook_hdp_f,
        comm_hdp_g: user.cm.comm_sportsbook_hdp_g,
        comm_hdp_h: user.cm.comm_sportsbook_hdp_h,
        comm_hdp_i: user.cm.comm_sportsbook_hdp_i,
        comm_hdp_j: user.cm.comm_sportsbook_hdp_j,
        comm_1x2: user.cm.comm_sportsbook_1x2,
        comm_others: user.cm.comm_sportsbook_others,
        comm_hdp_packages: user.cm.comm_sportsbook_hdp_packages,
        comm_slots: user.cm.comm_slots,
        comm_livecasino: user.cm.comm_casino,
        soccer_min_bet: user.bl.soccer_min_bet,
        soccer_max_bet: user.bl.soccer_max_bet,
        soccer_max_per_match: user.bl.soccer_max_per_match,
        basketball_min_bet: user.bl.basketball_min_bet,
        basketball_max_bet: user.bl.basketball_max_bet,
        basketball_max_per_match: user.bl.basketball_max_per_match,
        tennis_min_bet: user.bl.tennis_min_bet,
        tennis_max_bet: user.bl.tennis_max_bet,
        tennis_max_per_match: user.bl.tennis_max_per_match,
        baseball_min_bet: user.bl.baseball_min_bet,
        baseball_max_bet: user.bl.baseball_max_bet,
        baseball_max_per_match: user.bl.baseball_max_per_match,
        parlay_min_bet: user.bl.parlay_min_bet,
        parlay_max_bet: user.bl.parlay_max_bet,
        parlay_max_per_match: user.bl.parlay_max_per_match,
        esports_min_bet: user.bl.esports_min_bet,
        esports_max_bet: user.bl.esports_max_bet,
        esports_max_per_match: user.bl.esports_max_per_match,
        others_min_bet: user.bl.others_min_bet,
        others_max_bet: user.bl.others_max_bet,
        others_max_per_match: user.bl.others_max_per_match,
        livecasino_bet_limit_package: user.bl.livecasino_bet_limit_packages.join(','),
        hdp_mmo_upline_pt: user.pt.hdp_mmo_upline_pt,
        hdp_mmo_account_pt: user.pt.hdp_mmo_account_pt,
        hdp_mmo_upline_remaining: user.pt.hdp_mmo_upline_remaining,
        hdp_mmo_account_min: user.pt.hdp_mmo_account_min,
        parlay_mmo_upline_pt: user.pt.parlay_mmo_upline_pt,
        parlay_mmo_account_pt: user.pt.parlay_mmo_account_pt,
        parlay_mmo_upline_remaining: user.pt.parlay_mmo_upline_remaining,
        parlay_mmo_account_min: user.pt.parlay_mmo_account_min,
        comm_hdp_mmo: user.cm.comm_hdp_mmo,
        comm_parlay_mmo_a: user.cm.comm_parlay_mmo_a,
        comm_parlay_mmo_b: user.cm.comm_parlay_mmo_b,
        // pt: user.pt,
        // cm: user.cm,
        // bl: user.bl
      };
      // console.log(body)
      const feedback = {
        success: false,
        errorTag: errorTags.addAccount.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.addAccount == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addAccount", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addAccount",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.addAccount.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addAccount",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAccountList(context, user) {
      const url = config.getAccountListUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.member_id,
        search_id: user.search_id,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type,
        client_ip: user.client_ip
      };
      const feedback = {
        line: [],
        data: [],
        success: false,
        errorTag: errorTags.getAccountList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getAccountList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getAccountList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAccountList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.line = successResponse.body.ds.account_line;
                    feedback.data = successResponse.body.ds.account_list;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAccountList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAdminList(context, user) {
      const url = config.getAdminListUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        search_id: user.search_id,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type



        // login_id: this.state.user.login.login_id,
        // account_id: this.state.user.account.account_id,
        // profile_id: this.state.user.profile.profile_id,
        // auth_token: this.state.user.login.auth_token,
        // target_account_id: user.target_account_id,
        // search_id: user.search_id,
        // start_date: user.start_date,
        // end_date: user.end_date,
        // page_number: user.page_number,
        // page_size: user.page_size,
        // sort_key: user.sort_key,
        // sort_type: user.sort_type
      };
      const feedback = {
        line: [],
        data: [],
        success: false,
        errorTag: errorTags.getAccountList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getAccountList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getAccountList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAccountList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.line = successResponse.body.ds.account_line;
                    feedback.data = successResponse.body.ds.account_list;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAccountList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateAccountDetails(context, user) {
      const url = config.updateAccountDetailsUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        monday: user.payment.monday,
        tuesday: user.payment.tuesday,
        wednesday: user.payment.wednesday,
        thursday: user.payment.thursday,
        friday: user.payment.friday,
        saturday: user.payment.saturday,
        sunday: user.payment.sunday,
        full_name: user.full_name,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email,
        credit_limit: user.credit_limit,
        member_credit_limit: user.member_credit_limit,
        daily_reset: user.daily_reset,
        win_limit_multiplier: user.win_limit_multiplier,
        downline_limit: user.downline_limit
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.updateAccountDetails.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.updateAccountDetails.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.updateAccountDetails.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateAccountDetails == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateAccountDetails",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateAccountDetails",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateAccountDetails.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateAccountDetails",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAccountDetails(context, user) {
      const url = config.getAccountDetailsUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.account_id,
        client_ip: user.client_ip
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountDetails.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.getAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getAccountDetails == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getAccountDetails",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAccountDetails",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountDetails.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAccountDetails",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePassword(context, user) {
      const url = config.updatePasswordUrl();
      const body = {
          action_by: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          session_token: this.state.user.login.auth_token,
          password: user.password,
          new_password: user.new_password,
          login_id: this.state.user.login.login_id,
          client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("password" in user)) {
          feedback.errorTag = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.password.length <= 0) {
          feedback.errorTag = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateStatus(context, user) {
      const url = config.updateStatusUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.member_id,
        new_status: user.status,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateStatus.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("status" in user)) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.status.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateStatus == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updateStatus", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateStatus.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateStatusAdmin(context, user) {
      const url = config.updateStatusAdminUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.account_id,
        new_status: user.status,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateStatus.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("status" in user)) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.status.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateStatus == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updateStatus", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateStatus.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    unblockProfile(context, user) {
      const url = config.unblockProfileUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.member_id,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.unblockProfile.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.unblockProfile.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.unblockProfile.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.unblockProfile == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "unblockProfile", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "unblockProfile",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.unblockProfile.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "unblockProfile",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateAuthority(context, user) {
      const url = config.updateAuthorityUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        authority_option: user.authority_option.join(','),
        sub_login_id: user.login_id,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateAuthority.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.errorTag = errorTags.updateAuthority.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.login_id.length <= 0) {
          feedback.errorTag = errorTags.updateAuthority.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateAuthority == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateAuthority",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateAuthority",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateAuthority.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateAuthority",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    resetPassword(context, user) {
      const url = config.resetPasswordUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        login_id: user.target_login_id,
        new_password: user.new_password,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.resetPassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("target_login_id" in user)) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.target_login_id.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.resetPassword == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "resetPassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.resetPassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    resetPasswordAdmin(context, user) {
      const url = config.resetPasswordAdminUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        login_id: user.target_login_id,
        new_password: user.new_password,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.resetPassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("target_login_id" in user)) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.target_login_id.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.resetPassword == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "resetPassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.resetPassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    resetPasswordSub(context, user) {
      const url = config.resetPasswordSubUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        login_id: user.target_login_id,
        new_password: user.new_password,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.resetPassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("target_login_id" in user)) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.target_login_id.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.resetPassword == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "resetPassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.resetPassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    resetPasswordPost(context, user) {
      const url = config.resetPasswordPostUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        password: user.password,
        new_password: user.new_password,
        security_tag: user.security_tag,
        security_code: user.security_code,
        login_id: this.state.user.login.login_id,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("password" in user)) {
          feedback.errorTag = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_tag" in user)) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_code" in user)) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.password.length <= 0) {
          feedback.errorTag = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_tag.length <= 0) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_code.length <= 0) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    let security_disabled = 0;
                    let security_tag = body.security_tag;
                    context.commit("updateSecurityTag", { security_tag });
                    context.commit("updateSecurityDisabled", { security_disabled });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    subAccountBlock(context, user) {
      const url = config.subAccountBlockUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        sub_login_id: user.sub_login_id,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.subAccountBlock.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("sub_login_id" in user)) {
          feedback.errorTag = errorTags.subAccountBlock.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.sub_login_id.length <= 0) {
          feedback.errorTag = errorTags.subAccountBlock.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.subAccountBlock == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "subAccountBlock",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "subAccountBlock",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.subAccountBlock.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "subAccountBlock",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    subAccountUnblock(context, user) {
      const url = config.subAccountUnblockUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        sub_login_id: user.sub_login_id,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.subAccountUnblock.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("sub_login_id" in user)) {
          feedback.errorTag = errorTags.subAccountUnblock.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.sub_login_id.length <= 0) {
          feedback.errorTag = errorTags.subAccountUnblock.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.subAccountUnblock == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "subAccountUnblock",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "subAccountUnblock",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.subAccountUnblock.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "subAccountUnblock",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    checkDirectDownline(context, user) {
      const url = config.checkDirectDownlineUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.search_id
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.checkDirectDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.checkDirectDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.checkDirectDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.checkDirectDownline == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "checkDirectDownline",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "checkDirectDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.result;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.checkDirectDownline.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "checkDirectDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSchedule(context, user) {
      const url = config.getScheduleUrl();
      // let member_id = user ? user.member_id : this.state.user.account.account_id
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: "",
        member_id: user.member_id
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getSchedule.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getSchedule.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSchedule.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSchedule == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getSchedule", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSchedule",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    feedback.data = data;
                    if(body.account_id == user.member_id) {
                      context.commit("updateSchedule", { data });
                    }
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSchedule.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSchedule",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPositionTaking(context, user) {
      const url = config.getPositionTakingUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.account_id,
        platform_code: user.platform_code || null
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPositionTaking.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in body)) {
          feedback.errorTag = errorTags.getPositionTaking.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.member_id.length <= 0) {
          feedback.errorTag = errorTags.getPositionTaking.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getPositionTaking == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getPositionTaking",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPositionTaking",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;

                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    feedback.data = data;
                    context.commit("updatePT", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPositionTaking.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              console.log(errorResponse);
              context.commit("loading", {
                action: "getPositionTaking",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getChildPositionTaking(context, user) {
      const url = config.getPositionTakingUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.member_id,
        client_ip: user.client_ip,
        platform: user.platform_code
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPositionTaking.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.getPositionTaking.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.getPositionTaking.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getChildPositionTaking == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getChildPositionTaking",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getChildPositionTaking",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPositionTaking.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getChildPositionTaking",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getCommission(context, user) {
      const url = config.getCommissionUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.account_id,
        platform_code: user.platform_code || null
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getCommission.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.getCommission.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.getCommission.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getCommission == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getCommission", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getCommission",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    feedback.data = data;
                    context.commit("updateCM", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getCommission.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getCommission",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getChildCommission(context, user) {
      const url = config.getCommissionUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.member_id,
        client_ip: user.client_ip,
        platform: user.platform_code
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getCommission.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.getCommission.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.getCommission.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getChildCommission == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getChildCommission", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getChildCommission",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    feedback.data = data;
                    // context.commit("updateCM", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getCommission.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getChildCommission",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBetLimit(context, user) {
      const url = config.getBetLimitUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        // member_id: this.state.user.account.account_id,
        member_id: user.account_id,
        platform_code: user.platform_code || null
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getBetLimit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getBetLimit.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetLimit.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetLimit == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetLimit", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetLimit",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    feedback.data = data;
                    context.commit("updateBL", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetLimit.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetLimit",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getChildBetLimit(context, user) {
      const url = config.getBetLimitUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.member_id,
        platform: user.platform_code
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getBetLimit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.getBetLimit.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.getBetLimit.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getChildBetLimit == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getChildBetLimit",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getChildBetLimit",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetLimit.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getChildBetLimit",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDefaultBetLimit(context, user) {
      const url = config.getOperatorDefaultBetLimitUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        target_account_id: this.state.user.account.account_id
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getDefaultBetLimit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getDefaultBetLimit.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getDefaultBetLimit.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getDefaultBetLimit == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getDefaultBetLimit", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDefaultBetLimit",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    let betlimit = data.bet_limit;
                    feedback.data = data;
                    context.commit("updateOperatorBL", { betlimit });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDefaultBetLimit.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDefaultBetLimit",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getWallet(context) {
      const url = config.getWalletUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: "",
        member_id: this.state.user.account.account_id
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getWallet.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getWallet.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getWallet.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getWallet == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getWallet", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getWallet", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    context.commit("updateWallet", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getWallet.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              console.log(errorResponse)
              context.commit("loading", { action: "getWallet", status: false });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    //   const url = config.getProviderUrl();
    //   const body = {
    //     action_by: this.state.user.login.login_id,
    //     account_id: this.state.user.account.account_id,
    //     profile_id: this.state.user.profile.profile_id,
    //     session_token: this.state.user.login.auth_token,
    //     client_ip: user.client_ip,
    //     member_id: user.account_id,
    //     page_number: user.page_number,
    //     page_size: user.page_size,
    //     sort_key: user.sort_key,
    //     sort_type: user.sort_type,
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     errorTag: errorTags.getPlatform.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in body)) {
    //       feedback.errorTag = errorTags.getPlatform.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (body.account_id.length <= 0) {
    //       feedback.errorTag = errorTags.getPlatform.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (this.state.user._loading.getPlatform == true) {
    //       feedback.errorTag = errorTags.request.processing;
    //       canRequest = false;
    //     }
    //     if (canRequest == true) {
    //       context.commit("loading", { action: "getPlatform", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "getPlatform",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == true;
    //             }
    //             feedback.errorTag = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               var data = null;

    //               try {
    //                 data = successResponse.body.dt;
    //                 feedback.data = data;
    //                 if(body.data.account_id == body.auth.account_id) {
    //                   context.commit("updatePlatform", { data });
    //                 }
    //                 resolve(feedback);
    //               } catch (error) {
    //                 feedback.success = false;
    //                 feedback.errorTag = errorTags.getPlatform.failed;
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.errorTag == errorTags.session.expired ||
    //                 feedback.errorTag == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/expired");
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "getPlatform",
    //             status: false
    //           });
    //           feedback.errorTag = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    getCurrencyLookUp(context, user) {
      const url = config.currencyLookupUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: ""
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getCurrency.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getCurrency == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getCurrency", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getCurrency",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    context.commit("updateCurrencyLookUp", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getCurrency.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getCurrency",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPlatform(context, user) {
      const url = config.getProviderUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.account_id,
        sort_key: "",
        sort_type: "",
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPlatform.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getPlatform.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getPlatform.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getPlatform == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getPlatform", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    if(body.member_id == body.account_id) {
                      context.commit("updatePlatform", { data });
                    }
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPlatform.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPlatformLookUp(context, user) {
      const url = config.getPlatformLookUpUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPlatform.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getPlatform == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getPlatform", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    context.commit("updatePlatformLookUp", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPlatform.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePlatform(context, user) {
      const url = config.updateProviderUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.account_id,
        provider_code: user.provider_code,
        new_status: user.status
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateStatus.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("provider_code" in user)) {
          feedback.errorTag = errorTags.updateStatus.platformCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("status" in user)) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.provider_code.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.platformCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.status.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateStatus == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updateStatus", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateStatus.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getProviderLookup(context) {
      const url = config.providerLookupUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPlatform.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getPlatform == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getPlatform", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    context.commit("updatePlatform", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPlatform.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    resetWin(context, user) {
      const url = config.resetWinUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id
      };
      const feedback = {
        success: false,
        errorTag: errorTags.resetWin.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.resetWin.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.resetWin.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.resetWin == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "resetWin", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "resetWin", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.resetWin.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "resetWin", status: false });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getCreditUsedDownline(context, user) {
      const url = config.getCreditUsedDownlineUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          account_type: user.account_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getCreditUsedDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.getCreditUsedDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("account_type" in body.data)) {
          feedback.errorTag =
            errorTags.getCreditUsedDownline.accountTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.getCreditUsedDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_type.length <= 0) {
          feedback.errorTag =
            errorTags.getCreditUsedDownline.accountTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getCreditUsedDownline == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getCreditUsedDownline",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getCreditUsedDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data.downline[0].used_credit;
                    feedback.data = data;
                    context.commit("updateCreditUsedDownline", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getCreditUsedDownline.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getCreditUsedDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    //   const url = config.getCommissionUrl();
    //   const body = {
    //     auth: {
    //       login_id: this.state.user.login.login_id,
    //       account_id: this.state.user.account.account_id,
    //       profile_id: this.state.user.profile.profile_id,
    //       auth_token: this.state.user.login.auth_token
    //     },
    //     data: {
    //       account_id: user.account_id,
    //       platform_code: user.platform_code || null
    //     }
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     errorTag: errorTags.getCommission.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.errorTag = errorTags.getCommission.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (user.account_id.length <= 0) {
    //       feedback.errorTag = errorTags.getCommission.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (this.state.user._loading.getChildCommission == true) {
    //       feedback.errorTag = errorTags.request.processing;
    //       canRequest = false;
    //     }
    //     if (canRequest == true) {
    //       context.commit("loading", {
    //         action: "getChildCommission",
    //         status: true
    //       });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "getChildCommission",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.success == "string") {
    //               feedback.success = successResponse.body.success == "1";
    //             } else {
    //               feedback.success = successResponse.body.success == true;
    //             }
    //             feedback.errorTag = successResponse.body.errorTag;
    //             if (feedback.success == true) {
    //               var data = null;

    //               try {
    //                 data = successResponse.body.data;
    //                 feedback.data = data;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 feedback.success = false;
    //                 feedback.errorTag = errorTags.getCommission.failed;
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.errorTag == errorTags.session.expired ||
    //                 feedback.errorTag == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/expired");
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "getChildCommission",
    //             status: false
    //           });
    //           feedback.errorTag = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // getChildBetLimit(context, user) {
    //   const url = config.getBetLimitUrl();
    //   const body = {
    //     auth: {
    //       login_id: this.state.user.login.login_id,
    //       account_id: this.state.user.account.account_id,
    //       profile_id: this.state.user.profile.profile_id,
    //       auth_token: this.state.user.login.auth_token
    //     },
    //     data: {
    //       account_id: user.account_id,
    //       platform_code: user.platform_code || null
    //     }
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     errorTag: errorTags.getBetLimit.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.errorTag = errorTags.getBetLimit.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (user.account_id.length <= 0) {
    //       feedback.errorTag = errorTags.getBetLimit.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (this.state.user._loading.getChildBetLimit == true) {
    //       feedback.errorTag = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", {
    //         action: "getChildBetLimit",
    //         status: true
    //       });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "getChildBetLimit",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.success == "string") {
    //               feedback.success = successResponse.body.success == "1";
    //             } else {
    //               feedback.success = successResponse.body.success == true;
    //             }
    //             feedback.errorTag = successResponse.body.errorTag;
    //             if (feedback.success == true) {
    //               var data = null;

    //               try {
    //                 data = successResponse.body.data;
    //                 feedback.data = data;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 feedback.success = false;
    //                 feedback.errorTag = errorTags.getBetLimit.failed;
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.errorTag == errorTags.session.expired ||
    //                 feedback.errorTag == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/expired");
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "getChildBetLimit",
    //             status: false
    //           });
    //           feedback.errorTag = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // getChildPositionTaking(context, user) {
    //   const url = config.getPositionTakingUrl();
    //   const body = {
    //     auth: {
    //       login_id: this.state.user.login.login_id,
    //       account_id: this.state.user.account.account_id,
    //       profile_id: this.state.user.profile.profile_id,
    //       auth_token: this.state.user.login.auth_token
    //     },
    //     data: {
    //       account_id: user.account_id,
    //       platform_code: user.platform_code || null
    //     }
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     errorTag: errorTags.getPositionTaking.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.errorTag = errorTags.getPositionTaking.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (user.account_id.length <= 0) {
    //       feedback.errorTag = errorTags.getPositionTaking.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (this.state.user._loading.getChildPositionTaking == true) {
    //       feedback.errorTag = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", {
    //         action: "getChildPositionTaking",
    //         status: true
    //       });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "getChildPositionTaking",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.success == "string") {
    //               feedback.success = successResponse.body.success == "1";
    //             } else {
    //               feedback.success = successResponse.body.success == true;
    //             }
    //             feedback.errorTag = successResponse.body.errorTag;
    //             if (feedback.success == true) {
    //               var data = null;

    //               try {
    //                 data = successResponse.body.data;
    //                 feedback.data = data;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 feedback.success = false;
    //                 feedback.errorTag = errorTags.getPositionTaking.failed;
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.errorTag == errorTags.session.expired ||
    //                 feedback.errorTag == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/expired");
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "getChildPositionTaking",
    //             status: false
    //           });
    //           feedback.errorTag = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    updateCommissionSB(context, user) {
      const url = config.updateCommissionSBUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        comm_hdp_a: user.cm.hdp_a,
        comm_hdp_b: user.cm.hdp_b,
        comm_hdp_c: user.cm.hdp_c,
        comm_hdp_d: user.cm.hdp_d,
        comm_hdp_e: user.cm.hdp_e,
        comm_hdp_f: user.cm.hdp_f,
        comm_hdp_g: user.cm.hdp_g,
        comm_hdp_h: user.cm.hdp_h,
        comm_hdp_i: user.cm.hdp_i,
        comm_hdp_j: user.cm.hdp_j,
        comm_1x2: user.cm.one_x_two,
        comm_others: user.cm.others,
        comm_hdp_packages: user.cm.hdp_packages
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionSB.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionSB.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionSB.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionSB == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionSB",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionSB",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionSB.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionSB",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionMMO(context, user) {
      // console.log(user)
      const url = config.updateCommissionMMOUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        comm_hdp_mmo: user.cm.hdp,
        comm_parlay_mmo_a: user.cm.parlay_a,
        comm_parlay_mmo_b: user.cm.parlay_b
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionMMO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionMMO.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionMMO.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionMMO == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionMMO",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionMMO",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionMMO.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionMMO",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionSL(context, user) {
      const url = config.updateCommissionSLUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        comm_slots: user.comm_slots
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionSL.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionSL.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionSL.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionSL == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionSL",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionSL",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionSL.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionSL",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionLC(context, user) {
      const url = config.updateCommissionLCUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        comm_livecasino: user.comm_livecasino
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionLC.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionLC.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionLC.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionLC == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionLC",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionLC",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionLC.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionLC",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionLO(context, user) {
      const url = config.updateCommissionLOUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          account_commission: user.account_commission,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionLO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionLO == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionLO",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionLO",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionLO.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionLO",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionKN(context, user) {
      const url = config.updateCommissionKNUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          account_commission: user.account_commission,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionKN.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionKN == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionKN",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionKN",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionKN.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionKN",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionCF(context, user) {
      const url = config.updateCommissionCFUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          account_commission: user.account_commission,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionCF.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionCF == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionCF",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionCF",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionCF.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionCF",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionLT(context, user) {
      const url = config.updateCommissionLTUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          one_d: user.one_d,
          two_d: user.two_d,
          three_d: user.three_d,
          four_d: user.four_d,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionLT.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionLT == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionLT",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionLT",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionLT.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionLT",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitSB(context, user) {
      const url = config.updateBetLimitSBUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.member_id,
        soccer_min_bet: user.bl.soccer_min_bet,
        soccer_max_bet: user.bl.soccer_max_bet,
        soccer_max_per_match: user.bl.soccer_max_per_match,
        basketball_min_bet: user.bl.basketball_min_bet,
        basketball_max_bet: user.bl.basketball_max_bet,
        basketball_max_per_match: user.bl.basketball_max_per_match,
        tennis_min_bet: user.bl.tennis_min_bet,
        tennis_max_bet: user.bl.tennis_max_bet,
        tennis_max_per_match: user.bl.tennis_max_per_match,
        baseball_min_bet: user.bl.baseball_min_bet,
        baseball_max_bet: user.bl.baseball_max_bet,
        baseball_max_per_match: user.bl.baseball_max_per_match,
        parlay_min_bet: user.bl.parlay_min_bet,
        parlay_max_bet: user.bl.parlay_max_bet,
        parlay_max_per_match: user.bl.parlay_max_per_match,
        esports_min_bet: user.bl.esports_min_bet,
        esports_max_bet: user.bl.esports_max_bet,
        esports_max_per_match: user.bl.esports_max_per_match,
        others_min_bet: user.bl.others_min_bet,
        others_max_bet: user.bl.others_max_bet,
        others_max_per_match: user.bl.others_max_per_match,
        client_ip: user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitSB.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitSB.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitSB.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitSB == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitSB",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitSB",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitSB.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitSB",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitLC(context, user) {
      const url = config.updateBetLimitLCUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        bet_limit_packages: user.bet_limit_packages.join(',')
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitLC.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitLC.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitLC.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitLC == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitLC",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitLC",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitLC.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitLC",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitLO(context, user) {
      const url = config.updateBetLimitLOUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bet_limit_packages: user.bet_limit_packages,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitLO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitLO == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitLO",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitLO",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitLO.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitLO",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitKN(context, user) {
      const url = config.updateBetLimitKNUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bet_limit_packages: user.bet_limit_packages,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitKN.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitKN == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitKN",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitKN",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitKN.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitKN",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitCF(context, user) {
      const url = config.updateBetLimitCFUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bet_limit_packages: user.bet_limit_packages,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitCF.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitCF == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitCF",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitCF",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitCF.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitCF",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitLT(context, user) {
      const url = config.updateBetLimitLTUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bet_limit_packages: user.bet_limit_packages,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitLT.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitLT == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitLT",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitLT",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitLT.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitLT",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingSB1(context, user) {
      const url = config.updatePositionTakingSB1Url();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        hdp_upline_pt: user.pt.soccer_hdp_upline_pt,
        hdp_account_pt: user.pt.soccer_hdp_account_pt,
        hdp_upline_remaining: user.pt.soccer_hdp_upline_remaining,
        hdp_account_min: user.pt.soccer_hdp_account_min,
        oxt_upline_pt: user.pt.soccer_1x2_upline_pt,
        oxt_account_pt: user.pt.soccer_1x2_account_pt,
        oxt_upline_remaining: user.pt.soccer_1x2_upline_remaining,
        oxt_account_min: user.pt.soccer_1x2_account_min,
        parlay_upline_pt: user.pt.parlay_upline_pt,
        parlay_account_pt: user.pt.parlay_account_pt,
        parlay_upline_remaining: user.pt.parlay_upline_remaining,
        parlay_account_min: user.pt.parlay_account_min,
        others_upline_pt: user.pt.soccer_others_upline_pt,
        others_account_pt: user.pt.soccer_others_account_pt,
        others_upline_remaining: user.pt.soccer_others_upline_remaining,
        others_account_min: user.pt.soccer_others_account_min
      };

      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingSB1.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingSB1.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingSB1.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingSB1 == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingSB1",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSB1",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag =
                      errorTags.updatePositionTakingSB1.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSB1",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    //   const url = config.updatePositionTakingSBUrl();
    //   const body = {
    //     action_by: this.state.user.login.login_id,
    //     account_id: this.state.user.account.account_id,
    //     profile_id: this.state.user.profile.profile_id,
    //     session_token: this.state.user.login.auth_token,
    //     target_account_id: user.account_id,
    //     // pt: user.pt,
    //     soccer_hdp_upline_pt: user.pt.soccer_hdp_upline_pt,
    //     soccer_1X2_upline_pt: user.pt.soccer_1x2_upline_pt,
    //     soccer_others_upline_pt: user.pt.soccer_others_upline_pt,
    //     parlay_upline_pt: user.pt.parlay_upline_pt,
    //     audit_by: this.state.user.login.login_id

    //     // auth: {
    //     //   login_id: this.state.user.login.login_id,
    //     //   account_id: this.state.user.account.account_id,
    //     //   profile_id: this.state.user.profile.profile_id,
    //     //   auth_token: this.state.user.login.auth_token
    //     // },
    //     // data: {
    //     //   account_id: user.account_id,
    //     //   parent_id: this.state.user.account.account_id,
    //     //   pt: user.pt,
    //     //   audit_by: this.state.user.login.login_id
    //     // }
    //   };
    //   const feedback = {
    //     success: false,
    //     errorTag: errorTags.updatePositionTakingSB1.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.errorTag =
    //         errorTags.updatePositionTakingSB1.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (user.account_id.length <= 0) {
    //       feedback.errorTag =
    //         errorTags.updatePositionTakingSB1.accountIDRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (this.state.user._loading.updatePositionTakingSB1 == true) {
    //       feedback.errorTag = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", {
    //         action: "updatePositionTakingSB1",
    //         status: true
    //       });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "updatePositionTakingSB1",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == true;
    //             }
    //             feedback.errorTag = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 resolve(feedback);
    //               } catch (error) {
    //                 feedback.success = false;
    //                 feedback.errorTag =
    //                   errorTags.updatePositionTakingSB1.failed;
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.errorTag == errorTags.session.expired ||
    //                 feedback.errorTag == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/expired");
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "updatePositionTakingSB1",
    //             status: false
    //           });
    //           feedback.errorTag = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    updatePositionTakingSB2(context, user) {
      const url = config.updatePositionTakingSB2Url();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingSB2.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingSB2.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingSB2.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingSB2 == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingSB2",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSB2",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag =
                      errorTags.updatePositionTakingSB2.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSB2",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingMMO(context, user) {
      const url = config.updatePositionTakingMMOUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        hdp_mmo_upline_pt: user.pt.soccer_hdp_upline_pt,
        hdp_mmo_account_pt: user.pt.soccer_hdp_account_pt,
        hdp_mmo_upline_remaining: user.pt.soccer_hdp_upline_remaining,
        hdp_mmo_account_min: user.pt.soccer_hdp_account_min,
        parlay_mmo_upline_pt: user.pt.parlay_upline_pt,
        parlay_mmo_account_pt: user.pt.parlay_account_pt,
        parlay_mmo_upline_remaining: user.pt.parlay_upline_remaining,
        parlay_mmo_account_min: user.pt.parlay_account_min
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingMMO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingMMO.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingMMO.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingMMO == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingMMO",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingMMO",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag =
                      errorTags.updatePositionTakingMMO.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingMMO",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingSL(context, user) {
      const url = config.updatePositionTakingSLUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        slots_upline_pt: user.pt.slots_upline_pt,
        slots_account_pt: user.pt.slots_account_pt,
        slots_upline_remaining: user.pt.slots_upline_remaining,
        slots_account_min: user.pt.slots_account_min
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingSL.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingSL.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingSL.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingSL == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingSL",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSL",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePositionTakingSL.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSL",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingLC(context, user) {
      const url = config.updatePositionTakingLCUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        livecasino_upline_pt: user.pt.livecasino_upline_pt,
        livecasino_account_pt: user.pt.livecasino_account_pt,
        livecasino_upline_remaining: user.pt.livecasino_upline_remaining,
        livecasino_account_min: user.pt.livecasino_account_min
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingLC.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingLC.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingLC.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingLC == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingLC",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingLC",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePositionTakingLC.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingLC",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSettlementList(context, user) {
      const url = user.url;
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        search_id: user.search_id,
        account_status: user.status,
        show_all: user.show_all,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getSettlementList.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getSettlementList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSettlementList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSettlementList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSettlementList",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSettlementList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.dt;
                    // feedback.grandTotal = successResponse.body.data.grandtotal;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSettlementList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSettlementList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    settlementCash(context, user) {
      const url = config.settlementCashUrl()
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.account_id,
        amount: user.settle_amount,
        remark: user.remark
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.settlement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("amount" in body)) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.amount.length <= 0) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.settlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "settlement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.data.settlementList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.settlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    settlementCredit(context, user) {
      const url = config.settlementCreditUrl()
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.account_id,
        amount: user.settle_amount,
        remark: user.remark
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.settlement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("amount" in body)) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.amount.length <= 0) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.settlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "settlement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.data.settlementList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.settlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSettlementHistory(context, user) {
      const url = config.getSettlementHistoryUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        search_id: user.search_id,
        start_date: user.start_date,
        end_date: user.end_date,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getSettlementHistory.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!(body.account_id)) {
          feedback.errorTag = errorTags.getSettlementHistory.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSettlementHistory.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSettlementHistory == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSettlementHistory",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSettlementHistory",
                status: false
              });
              if (successResponse) {
                // console.log(successResponse)
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.ds.report_data;
                    feedback.grandTotal = successResponse.body.ds.grand_total;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSettlementHistory.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSettlementHistory",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSettlementHistoryDownline(context, user) {
      const url = config.getSettlementHistoryDownlineUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        search_id: user.search_id,
        member_id: user.member_id,
        start_date: user.start_date,
        end_date: user.end_date,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getSettlementHistory.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!(body.account_id)) {
          feedback.errorTag = errorTags.getSettlementHistory.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSettlementHistory.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSettlementHistory == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSettlementHistory",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSettlementHistory",
                status: false
              });
              if (successResponse) {
                // console.log(successResponse)
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.ds.report_data;
                    feedback.grandTotal = successResponse.body.ds.grand_total;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSettlementHistory.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSettlementHistory",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDailyStatement(context, user) {
      const url = config.getDailyStatementUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.search_id,
        start_date: user.start_date,
        end_date: user.end_date,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getDailyStatement.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getDailyStatement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getDailyStatement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getDailyStatement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getDailyStatement",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDailyStatement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.ds.report_data;
                    feedback.grandTotal = successResponse.body.ds.grand_total;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDailyStatement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailyStatement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDailySettlement(context, user) {
      const url = config.getDailySettlementUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        account_id: user.account_id,
        working_date: user.working_date
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getDailySettlement.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getDailySettlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getDailySettlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getDailySettlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getDailySettlement",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDailySettlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.ds.report_data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDailySettlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailySettlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDailyWinlose(context, user) {
      const url = user.url;
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.target_id,
        search_id: user.search_id,
        currency: user.currency,
        start_date: user.start_date,
        end_date: user.end_date,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type,
        client_ip: user.client_ip
      };
      const feedback = {
        report_data: [],
        grand_total: [],
        account_line: [],
        success: false,
        errorTag: errorTags.getDailyWinlose.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!(body.account_id)) {
          feedback.errorTag = errorTags.getDailyWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getDailyWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getDailyWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getDailyWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDailyWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.report_data = successResponse.body.ds.report_data;
                    feedback.grand_total = successResponse.body.ds.grand_total;
                    feedback.account_line = successResponse.body.ds.account_line;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDailyWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailyWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDailyWinloseAIO(context, user) {
      const url = user.url;
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.target_id,
        search_id: user.search_id,
        currency: user.currency,
        start_date: user.start_date,
        end_date: user.end_date,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type,
        client_ip: user.client_ip
      };
      const feedback = {
        report_data: [],
        grand_total: [],
        account_line: [],
        success: false,
        errorTag: errorTags.getDailyWinlose.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!(body.account_id)) {
          feedback.errorTag = errorTags.getDailyWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getDailyWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getDailyWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getDailyWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDailyWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.report_data = successResponse.body.ds.report_data;
                    feedback.grand_total = successResponse.body.ds.grand_total;
                    feedback.account_line = successResponse.body.ds.account_line;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDailyWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailyWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPlatformWinlose(context, user) {
      const url = user.url;
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        search_id: user.search_id,
        start_date: user.start_date,
        end_date: user.end_date,
        currency: user.currency
      };
      const feedback = {
        report_data: [],
        grand_total: [],
        success: false,
        errorTag: errorTags.getPlatformWinlose.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getPlatformWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (!("search_id" in body)) {
        //   feedback.errorTag = errorTags.getPlatformWinlose.searchIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getPlatformWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (body.search_id.length <= 0) {
        //   feedback.errorTag = errorTags.getPlatformWinlose.searchIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.getPlatformWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getPlatformWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPlatformWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.report_data = successResponse.body.ds.report_data;
                    feedback.grand_total = successResponse.body.ds.grand_total;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPlatformWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPlatformWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSportTypeWinlose(context, user) {
      const url = user.url;
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        search_id: user.search_id,
        start_date: user.start_date,
        end_date: user.end_date
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getSportTypeWinlose.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getSportTypeWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("search_id" in body)) {
          feedback.errorTag = errorTags.getSportTypeWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSportTypeWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.search_id.length <= 0) {
          feedback.errorTag = errorTags.getSportTypeWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSportTypeWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSportTypeWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSportTypeWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.ds.sport_type_winlose;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSportTypeWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSportTypeWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPendingMatches(context) {
      const url = config.getPendingMatchesUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token

      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPendingMatches.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getPendingMatches.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getPendingMatches.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getPendingMatches == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getPendingMatches",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPendingMatches",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.dt;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPendingMatches.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPendingMatches",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getGameResultDetail(context, user) {
      const url = user.url;
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        start_date: user.start_date,
        end_date: user.end_date,
        provider_code: user.provider_code,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type
      };
      const feedback = {
        data: [],
        names: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getGameResult.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("member_id" in body)) {
          feedback.errorTag = errorTags.getGameResult.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getGameResult.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.member_id.length <= 0) {
          feedback.errorTag = errorTags.getGameResult.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getGameResult == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getGameResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getGameResult",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.ds.report_data;
                    // feedback.names = successResponse.body.ds.names;
                    feedback.grandTotal = successResponse.body.ds.grand_total;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getGameResult.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getGameResult",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getParlayDetail(context, user) {
      const url = config.getParlayDetailUrl();
      const body = {
          action_by: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          session_token: this.state.user.login.auth_token,
          bet_id: user.bet_id
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getParlayDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!(body.bet_id)) {
          feedback.errorTag = errorTags.getParlayDetail.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.bet_id.length <= 0) {
          feedback.errorTag = errorTags.getParlayDetail.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getParlayDetail == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", {
            action: "getParlayDetail",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getParlayDetail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.dt;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getParlayDetail.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getParlayDetail",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMatchResultParlayDetail(context, user) {
      const url = config.getMatchResultParlayDetailUrl();
      const body = {
          action_by: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          session_token: this.state.user.login.auth_token,
          bet_id: user.bet_id
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getParlayDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!(body.bet_id)) {
          feedback.errorTag = errorTags.getParlayDetail.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.bet_id.length <= 0) {
          feedback.errorTag = errorTags.getParlayDetail.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getParlayDetail == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", {
            action: "getParlayDetail",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getParlayDetail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.dt;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getParlayDetail.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getParlayDetail",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getGameTypeLookup(context, user) {
      const url = config.getGameTypeLookupUrl();
      const body = {
        // auth: {
          action_by: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          session_token: this.state.user.login.auth_token
        // }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getGameTypeLookup.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        // if (this.state.user._loading.getGameTypeLookup == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }
        if (canRequest == true) {
          // context.commit("loading", {
          //   action: "getGameTypeLookup",
          //   status: true
          // });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", {
              //   action: "getGameTypeLookup",
              //   status: false
              // });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;
                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    context.commit("updateGameTypeLookUp", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getGameTypeLookup.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", {
              //   action: "getGameTypeLookup",
              //   status: false
              // });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getLeagueLookup(context, user) {
      const url = config.getLeagueLookupUrl();
      const body = {
          action_by: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          session_token: this.state.user.login.auth_token,
          working_date: user.working_date,
          game_type: user.game_type
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getLeagueLookup.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!(body.working_date)) {
          feedback.errorTag = errorTags.getLeagueLookup.dateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!(body.game_type)) {
          feedback.errorTag = errorTags.getLeagueLookup.gameTypeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.working_date.length <= 0) {
          feedback.errorTag = errorTags.getLeagueLookup.dateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.game_type.length <= 0) {
          feedback.errorTag = errorTags.getLeagueLookup.gameTypeRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.getLeagueLookup == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }
        if (canRequest == true) {
          // context.commit("loading", {
          //   action: "getLeagueLookup",
          //   status: true
          // });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", {
              //   action: "getLeagueLookup",
              //   status: false
              // });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    context.commit("updateLeagueLookUp", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getLeagueLookup.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", {
              //   action: "getLeagueLookup",
              //   status: false
              // });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    checkDownline(context, id) {
      const url = config.checkDownlineUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: id
      };
      const feedback = {
        success: false,
        errorTag: errorTags.checkDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.checkDownline == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "checkDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                resolve(feedback);
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    checkAccountReserved(context, id) {
      const url = config.checkAccountReservedUrl();
      const body = {
          action_by: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          session_token: this.state.user.login.auth_token,
          member_id: id
      };
      const feedback = {
        success: false,
        errorTag: errorTags.checkDownline.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.checkDownline == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }
        if (canRequest == true) {
          context.commit("loading", { action: "checkDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                feedback.result = successResponse.body.result;
                resolve(feedback);
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    checkDownlineExist(context, id) {
      const url = config.checkDownlineExistUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: id
      };
      const feedback = {
        success: false,
        errorTag: errorTags.checkDownline.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.member_id.length <= 0) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.checkDownline == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }
        if (canRequest == true) {
          context.commit("loading", { action: "checkDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                feedback.result = successResponse.body.result;
                resolve(feedback);
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromotionList(context, user) {
      const url = config.getPromotionListUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        agent_id: user.agent_id,
        search_id: user.promotion_id,
        promo_status: user.promo_status == '' ? null : user.promo_status,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type,
        client_ip: user.client_ip
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSubAccountList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSubAccountList",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSubAccountList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.dt;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSubAccountList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePromotionStatus(context, user) {
      const url = config.updatePromotionStatusUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        promotion_id: user.promotion_id,
        new_status: user.status
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePromoStatus.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("promotion_id" in user)) {
          feedback.errorTag = errorTags.updatePromoStatus.promotionIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("status" in user)) {
          feedback.errorTag = errorTags.updatePromoStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.promotion_id.length <= 0) {
          feedback.errorTag = errorTags.updatePromoStatus.promotionIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.status.length <= 0) {
          feedback.errorTag = errorTags.updatePromoStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePromoStatus == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePromoStatus", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePromoStatus",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePromoStatus.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePromoStatus",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addPromotion(context, user) {
      const url = config.addPromotionUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        promotion_id: user.promotion_id,
        promotion_name: user.promotion_name,
        min_deposit: user.min_deposit,
        bonus_rate: user.bonus_rate,
        rollover: user.rollover,
        criteria: user.criteria,
        remark: user.remark,
        client_ip : user.client_ip
      };
      const feedback = {
        success: false,
        errorTag: errorTags.addAccount.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (!("new_login_id" in user)) {
        //   feedback.errorTag = errorTags.addAccount.loginIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (!("new_password" in user)) {
        //   feedback.errorTag = errorTags.addAccount.passwordRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (user.new_login_id.length <= 0) {
        //   feedback.errorTag = errorTags.addAccount.loginIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (user.new_password.length <= 0) {
        //   feedback.errorTag = errorTags.addAccount.passwordRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (this.state.user._loading.addAccount == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          context.commit("loading", { action: "addSubAccount", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addSubAccount",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.addAccount.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addSubAccount",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    transferCash(context, user) {
      const url = user.url;
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.member_id,
        amount: user.settle_amount,
        remark: user.remark
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.settlement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("settle_amount" in user)) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.amount.length <= 0) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.settlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "settlement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.data.settlementList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.settlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addAdmin(context, user) {
      const url = config.addAdminUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip : user.client_ip,
        member_id: user.account_id,
        password: user.password,
        full_name: user.full_name,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email,
      };
      const feedback = {
        success: false,
        errorTag: errorTags.addAdmin.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.addAdmin.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("password" in user)) {
          feedback.errorTag = errorTags.addAdmin.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.addAdmin.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.password.length <= 0) {
          feedback.errorTag = errorTags.addAdmin.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addAdmin == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addAdmin", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addAdmin",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.addAdmin.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addAdmin",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTicketList(context, user) {
      const url = config.getTicketListUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: user.member_id,
        request_type: user.request_type,
        ticket_status: user.ticket_status,
        page_number: user.page_number,
        page_size: user.page_size,
        sort_key: user.sort_key,
        sort_type: user.sort_type,
        client_ip: user.client_ip,
        start_date: user.start_date,
        end_date: user.end_date
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getTicketList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (!("member_id" in body)) {
        //   feedback.errorTag = errorTags.getTicketList.memberIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (body.member_id.length <= 0) {
        //   feedback.errorTag = errorTags.getTicketList.memberIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.getTicketList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getTicketList",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getTicketList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.dt;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getTicketList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getTicketList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    ticketProcess(context, user) {
      const url = config.processTicketUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        ticket_id: user.id,
        action_status: user.status,
        remark: user.remark
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.ticketProcess.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (!("account_id" in body)) {
        //   feedback.errorTag = errorTags.settlement.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (!("settle_amount" in user)) {
        //   feedback.errorTag = errorTags.settlement.settleAmountRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (body.account_id.length <= 0) {
        //   feedback.errorTag = errorTags.settlement.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (body.amount.length <= 0) {
        //   feedback.errorTag = errorTags.settlement.settleAmountRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.ticketProcess == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "ticketProcess", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "ticketProcess",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.data.settlementList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.ticketProcess.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "ticketProcess",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getProviderWinlose(context, user) {
      const url = user.url;
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        member_id: user.search_id,
        start_date: user.start_date,
        end_date: user.end_date,
        currency: user.currency,
        platform: user.platform
      };
      const feedback = {
        report_data: [],
        grand_total: [],
        success: false,
        errorTag: errorTags.getPlatformWinlose.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body)) {
          feedback.errorTag = errorTags.getPlatformWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (!("member_id" in body)) {
        //   feedback.errorTag = errorTags.getPlatformWinlose.searchIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (body.account_id.length <= 0) {
          feedback.errorTag = errorTags.getPlatformWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (body.member_id.length <= 0) {
        //   feedback.errorTag = errorTags.getPlatformWinlose.searchIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.getPlatformWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getPlatformWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPlatformWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.report_data = successResponse.body.ds.report_data;
                    feedback.grand_total = successResponse.body.ds.grand_total;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPlatformWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPlatformWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getNekoResult(context, user) {
      const url = config.nkPath;
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getNekoResult.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getNekoResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getNekoResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getNekoResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getNekoResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getDashboardInfo == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", {
          //   action: "getDashboardInfo",
          //   status: true
          // });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", {
              //   action: "getDashboardInfo",
              //   status: false
              // });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.status == "200";
                } else {
                  feedback.success = successResponse.status == 200;
                }
                feedback.errorTag = successResponse.statusText;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getNekoResult.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", {
              //   action: "getDashboardInfo",
              //   status: false
              // });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDomainInfo(context, user) {
      const url = config.getDomainInfoUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getDomainInfo.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getDomainInfo == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getDomainInfo",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDomainInfo",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {

                  try {
                    feedback.agent_site = successResponse.body.agent_site;
                    feedback.member_site = successResponse.body.member_site;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDomainInfo.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDomainInfo",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDashboardInfo(context, user) {
      const url = config.getDashboardInfoUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getDashboardInfo.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (!("account_id" in user)) {
        //   feedback.errorTag = errorTags.getDashboardInfo.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (user.account_id.length <= 0) {
        //   feedback.errorTag = errorTags.getDashboardInfo.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.getDashboardInfo == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getDashboardInfo",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDashboardInfo",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.ds;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDashboardInfo.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDashboardInfo",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBankAccount(context, user) {
      const url = config.bankAccountGetUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: this.state.user.account.account_id
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getBankAccount.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (!("account_id" in user)) {
        //   feedback.errorTag = errorTags.getBankAccount.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (user.account_id.length <= 0) {
        //   feedback.errorTag = errorTags.getBankAccount.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        if (this.state.user._loading.getBankAccount == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getBankAccount",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBankAccount",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBankAccount.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBankAccount",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSocialAccount(context, user) {
      const url = config.accountSocialGetUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        member_id: this.state.user.account.account_id
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountSocial.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (!("account_id" in user)) {
        //   feedback.errorTag = errorTags.getAccountSocial.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (user.account_id.length <= 0) {
        //   feedback.errorTag = errorTags.getAccountSocial.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.getAccountSocial == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getAccountSocial",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAccountSocial",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.dt;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountSocial.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAccountSocial",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBankAccount(context, user) {
      const url = config.bankAccountUpsertUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        bank_name: user.bank_name,
        bank_acc_no: user.bank_acc_no,
        bank_acc_holder: user.bank_acc_holder
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.upsertBankAccount.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (!("account_id" in body)) {
        //   feedback.errorTag = errorTags.settlement.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (!("settle_amount" in user)) {
        //   feedback.errorTag = errorTags.settlement.settleAmountRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (body.account_id.length <= 0) {
        //   feedback.errorTag = errorTags.settlement.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (body.amount.length <= 0) {
        //   feedback.errorTag = errorTags.settlement.settleAmountRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.upsertBankAccount == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "upsertBankAccount", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "upsertBankAccount",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.data.settlementList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.upsertBankAccount.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "upsertBankAccount",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateSocialAccount(context, user) {
      const url = config.accountSocialUpsertUrl();
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: user.client_ip,
        contact_phone: user.contact_phone,
        telegram: user.telegram,
        viber: user.viber,
        whatsapp: user.whatsapp
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.upsertAccountSocial.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (!("account_id" in body)) {
        //   feedback.errorTag = errorTags.settlement.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (!("settle_amount" in user)) {
        //   feedback.errorTag = errorTags.settlement.settleAmountRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (body.account_id.length <= 0) {
        //   feedback.errorTag = errorTags.settlement.accountIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (body.amount.length <= 0) {
        //   feedback.errorTag = errorTags.settlement.settleAmountRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.upsertAccountSocial == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "upsertAccountSocial", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "upsertAccountSocial",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.data.settlementList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.upsertAccountSocial.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "upsertAccountSocial",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
  }
};
